var data = {
  pops:[
    {sqno:0, ppupTyp:'0', dt:'YYYYMMDD'}
  ]
};

var mutations = {
  'SET_POP'(state, pop) {
    var idx = -1;
    for(var i=0;i<state.pops.length;i++) {
      var item = state.pops[i];
      if(pop.sqno == item.sqno) {
        idx = i;
      }
    }
    if(idx != -1) {
      console.log('store.js pop.js idx', idx);
      state.pops.splice(idx, 1);
    }

    state.pops.push(pop);
  }
};

var getters = {
  pops: state => state.pops
};

export default {
  state: data,
  getters,
  // actions,
  mutations
}
